import { getAxiosInstance } from "../axios-instance";
import { Patient } from "./models/Patient";

export type GetPatientsResult = { items: Patient[]; total: number };

export const getPatientsApi = async ({
  offset,
  limit,
  search,
}: {
  offset?: number;
  limit?: number;
  search?: string;
} = {}): Promise<GetPatientsResult> => {
  const paramsRecord: Record<string, number | string> = {};
  if (offset !== undefined) paramsRecord.offset = offset;
  if (limit !== undefined) paramsRecord.limit = limit;
  if (search) paramsRecord.search = search;

  const params = Object.keys(paramsRecord).length ? paramsRecord : undefined;
  return getAxiosInstance()
    .get<GetPatientsResult>("/patients", { params })
    .then((response) => response.data);
};

export const getPatientByIdApi = (id: number) => {
  return getAxiosInstance()
    .get<Patient>(`/patients/${id}`)
    .then((response) => response.data);
};

export const getPatientsAutocompleteApi = async (): Promise<{ id: number; fullName: string }[]> => {
  const response = await getAxiosInstance().get<{ id: number; fullName: string }[]>("/patients/autocomplete");
  return response.data;
};

export const createPatientApi = (patient: Omit<Patient, "id" | "photoUrl">): Promise<Patient> => {
  return getAxiosInstance()
    .post<Patient>("/patients", patient)
    .then((response) => response.data);
};

export const deletePatientApi = (id: number) => {
  return getAxiosInstance()
    .delete<void>(`/patients/${id}`)
    .then(() => {});
};

export const updatePatientApi = (id: number, patient: Partial<Patient>) =>
  getAxiosInstance()
    .put(`/patients/${id}`, patient)
    .then((res) => res.data);
